import getLang from 'I18n/utils/getLang';
import unescapedText from 'I18n/utils/unescapedText';
import { View } from 'foundations-components/components/View';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import { Image } from 'foundations-components/transitional/components/Image';
import { useMemo } from 'react';
import { EcosystemSlider } from 'trellis-ecosystem';
import { GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY as PUBLIC_GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY, GET_SEARCH_FILTER_CONFIG_QUERY as PUBLIC_GET_SEARCH_FILTER_CONFIG_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontPublicRpc.dfc.new';
import { GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY, GET_SEARCH_FILTER_CONFIG_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/storefront/service/rpc/MarketplaceStorefrontRpc.dfc.new';
import { CollectionCard } from '../../collections/components/CollectionCard';
import { Paths } from '../../constants/paths';
import { Subscreens } from '../../constants/usage';
import { useAppContextQuery } from '../../hooks/useAppContextQuery';
import { useScrollToTop } from '../../hooks/useScrollToTop';
import { isQa } from '../../utils/env';
import { SUGGESTED_ACCREDITATIONS } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
export function SuggestedAccreditations() {
  var _batchFilterOptionsRe, _searchFilterConfigRe;
  const scrollToTop = useScrollToTop();
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const searchFilterConfigResult = useAppContextQuery({
    app: GET_SEARCH_FILTER_CONFIG_QUERY,
    public: PUBLIC_GET_SEARCH_FILTER_CONFIG_QUERY,
    options: {
      variables: {
        language: getLang()
      }
    }
  });
  const batchFilterOptionsResult = useAppContextQuery({
    app: GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY,
    public: PUBLIC_GET_BATCH_SEARCH_FILTER_OPTIONS_QUERY,
    options: {
      variables: {
        filters: {
          PROFILE_ACCREDITATIONS: SUGGESTED_ACCREDITATIONS
        },
        language: getLang(),
        includeHelpText: true
      }
    }
  });
  const trackCollectionCardClicked = (filter, index) => {
    var _filter$text;
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'filter card clicked',
      category: (_filter$text = filter.text) !== null && _filter$text !== void 0 ? _filter$text : '',
      itemIndex: index,
      subscreen: Subscreens.SUGGESTED_ACCREDITATIONS
    }));
  };
  const trackSliderButtonClicked = direction => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: `suggested filter section ${direction} arrow clicked`,
      // Hardcoded index based on figma design layout
      itemIndex: 2,
      subscreen: Subscreens.SUGGESTED_ACCREDITATIONS
    }));
  };
  const batchResults = (_batchFilterOptionsRe = batchFilterOptionsResult.data) === null || _batchFilterOptionsRe === void 0 ? void 0 : _batchFilterOptionsRe.result.filterOptions['PROFILE_ACCREDITATIONS'];
  const searchFilterResults = (_searchFilterConfigRe = searchFilterConfigResult.data) === null || _searchFilterConfigRe === void 0 || (_searchFilterConfigRe = _searchFilterConfigRe.result.filterConfigs['PROFILE_ACCREDITATIONS']) === null || _searchFilterConfigRe === void 0 ? void 0 : _searchFilterConfigRe.options;
  const accreditations = useMemo(() => {
    if (!batchResults && !searchFilterResults) return [];
    if (isQa() && searchFilterResults) {
      return [...searchFilterResults].sort(() => Math.random() - 0.5).slice(0, 6);
    }
    return batchResults || [];
  }, [batchResults, searchFilterResults]);
  if (!accreditations.length) return null;
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "suggested-accreditations-section",
    marginBlockEnd: "1000",
    maxInlineSize: "100%",
    children: /*#__PURE__*/_jsx(EcosystemSlider, {
      cardWidth: 625,
      gradientColor: "fill-surface-recessed",
      onScrollButtonClick: trackSliderButtonClicked
      // I've eyeballed this so the center of the scroll buttons aligns with the bottom of the card image background
      ,
      scrollButtonTop: "43.5%",
      title: unescapedText('marketplaceStorefront.suggestedFilters.title'),
      description: unescapedText('marketplaceStorefront.suggestedFilters.description'),
      children: accreditations.map((accreditation, index) => {
        var _accreditation$helpTe;
        return /*#__PURE__*/_jsx(CollectionCard, {
          buttonText: unescapedText('marketplaceStorefront.suggestedFilters.buttonText', {
            accreditation: accreditation.text
          }),
          description: (_accreditation$helpTe = accreditation.helpText) !== null && _accreditation$helpTe !== void 0 ? _accreditation$helpTe : '',
          href: `${Paths.SEARCH_RESULTS_SOLUTIONS_PARTNERS}?eco_PROFILE_ACCREDITATIONS=${accreditation.value}`,
          illustration: accreditation.icon ? /*#__PURE__*/_jsx(Image, {
            alt: "",
            inlineSize: "125px",
            responsive: false,
            src: accreditation.icon
          }) : undefined,
          name: accreditation.text,
          onClick: () => {
            trackCollectionCardClicked(accreditation, index);
            scrollToTop();
          },
          slug: accreditation.value
        }, accreditation.value);
      })
    })
  });
}